require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-tom-lingham-bs-node-http.json") })
        }
      }, "path---package-unpublished-tom-lingham-bs-node-http");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-tom-lingham-bs-node-http!./.cache/json/package-unpublished-tom-lingham-bs-node-http.json
// module id = 970
// module chunks = 231608221292675